// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"222":"6596a760","239":"02bd13dd","322":"92805073","356":"a51ae278","579":"e337e514","601":"45860998","776":"43104926"}[chunkId] + ".chunk.css";
};